import React from 'react';
import { TableRow, TableCell, Checkbox, Typography } from '@mui/material';
import { useStyles } from './styles';
import { IUserMenu } from '../../categoriesManagement.types';

interface CategoriesTableRowProps {
  item: IUserMenu;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

const CategoriesTableRow: React.FC<CategoriesTableRowProps> = ({ item, isSelected, onSelect }) => {
  const classes = useStyles();

  return (
    <TableRow hover className={classes.TableRow} role="checkbox" aria-checked={isSelected} selected={isSelected}>
      <TableCell padding="checkbox">
        <Checkbox color="primary" checked={isSelected} onChange={() => onSelect(item.id)} />
      </TableCell>
      <TableCell>
        <img src={item.imageUrl} alt={item.foodName} className={classes.FoodImage} />
      </TableCell>
      <TableCell>
        <Typography fontSize={14} fontWeight={400} color="var(--Gray-600, #475467)">
          {item.foodName}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography fontSize={14} fontWeight={400} color="var(--Gray-600, #475467)">
          {item.foodTruck}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography fontSize={14} fontWeight={400} color="var(--Gray-600, #475467)">
          {item.price}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography fontSize={14} fontWeight={400} color="var(--Gray-600, #475467)">
          {item.category}
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export default CategoriesTableRow;
